import {create} from 'zustand';
import {ExamOrientationsModalStore} from './types';

const useExamOrientationsModalStore = create<ExamOrientationsModalStore>(set => ({
	isOpen: false,
	setIsOpen: value => set({isOpen: value}),
}));

export {useExamOrientationsModalStore};
